const donationReducer = () => {
  return { isPromptAllowed: false };
};

export default donationReducer;
